// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"7fa47b80","122":"ade71ef0","126":"83f6657a","211":"7e56fe07","453":"8d4df37b","458":"3eab7e3a","465":"defbf2a5","552":"3755801c","737":"82f11f15","952":"7e9dc070"}[chunkId] + ".chunk.js";
};